import { Locale, type LocalizedString } from "../Locale.js";

export const blogPathMap = {
	[Locale.cs]: "blog" as const,
} satisfies LocalizedString;
